import GoogleSignup from './googleSignup'

export default GoogleSignup
